import React from "react";
import { 
 FaFileAlt, FaUserTie, FaUsers, FaTasks, FaFileSignature, 
 FaHandshake, FaClipboardCheck, FaFolderOpen, FaBuilding,
 FaPlus, FaEdit, FaTrash, FaQuestionCircle, FaTruck, FaFileInvoice,
 FaShoppingCart, FaClipboardList, FaFileContract, FaClock
} from "react-icons/fa";

/**
 * Maps module name to an icon and background color
 */
export const getModuleInfo = (moduleName) => {
 const mod = (moduleName || "").toLowerCase();
 
 // CX360 brand theme — Blue #0078D7 / Orange #F47920
 const primaryColor = "#0078D7";
 const primaryBg = "rgba(0, 120, 215, 0.08)";
 const orangeColor = "#F47920";
 const orangeBg = "rgba(244, 121, 32, 0.08)";
 const mutedGrey = "#4A5568";
 const mutedBg = "#F4F6FA";

 const mapping = {
 workorder: { icon: <FaTasks />, color: primaryColor, bg: primaryBg },
 purchaseorder: { icon: <FaShoppingCart />, color: orangeColor, bg: orangeBg },
 vendor: { icon: <FaUserTie />, color: orangeColor, bg: orangeBg },
 user: { icon: <FaUsers />, color: mutedGrey, bg: mutedBg },
 users: { icon: <FaUsers />, color: mutedGrey, bg: mutedBg },
 client: { icon: <FaBuilding />, color: primaryColor, bg: primaryBg },
 project: { icon: <FaFolderOpen />, color: primaryColor, bg: primaryBg },
 indent: { icon: <FaFileAlt />, color: mutedGrey, bg: mutedBg },
 mir: { icon: <FaClipboardList />, color: orangeColor, bg: orangeBg },
 delivery: { icon: <FaTruck />, color: orangeColor, bg: orangeBg },
 billing: { icon: <FaFileInvoice />, color: orangeColor, bg: orangeBg },
 jmr: { icon: <FaFileSignature />, color: mutedGrey, bg: mutedBg },
 tc: { icon: <FaFileContract />, color: primaryColor, bg: primaryBg },
 handover: { icon: <FaHandshake />, color: primaryColor, bg: primaryBg },
 dpr: { icon: <FaClipboardCheck />, color: mutedGrey, bg: mutedBg },
 staffattendance: { icon: <FaClock />, color: primaryColor, bg: primaryBg },
 task: { icon: <FaTasks />, color: primaryColor, bg: primaryBg },
 document: { icon: <FaFileAlt />, color: mutedGrey, bg: mutedBg },
 "boq amendment": { icon: <FaFileSignature />, color: orangeColor, bg: orangeBg },
 };

 return mapping[mod] || { icon: <FaQuestionCircle />, color: "#adb5bd", bg: "#F4F6FA" };
};

/**
 * Maps action type to a color and label
 */
export const getActionInfo = (action) => {
 const act = (action || "").toLowerCase();
 
 const mapping = {
 create: { icon: <FaPlus />, color: "success", label: "Created", textColor: "#28A745" },
 update: { icon: <FaEdit />, color: "info", label: "Updated", textColor: "#0078D7" },
 delete: { icon: <FaTrash />, color: "danger", label: "Deleted", textColor: "#DC3545" },
 };

 return mapping[act] || { icon: null, color: "secondary", label: action || "Action", textColor: "#4A5568" };
};

/**
 * Formats a date to relative time (e.g. 2 mins ago)
 */
export const getRelativeTime = (date) => {
 if (!date) return "";
 
 const now = new Date();
 const past = new Date(date);
 const diffInSeconds = Math.floor((now - past) / 1000);
 
 if (diffInSeconds < 60) return "just now";
 
 const diffInMinutes = Math.floor(diffInSeconds / 60);
 if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
 
 const diffInHours = Math.floor(diffInMinutes / 60);
 if (diffInHours < 24) return `${diffInHours}h ago`;
 
 const diffInDays = Math.floor(diffInHours / 24);
 if (diffInDays < 7) return `${diffInDays}d ago`;
 
 // Return formatted date for older items
 return past.toLocaleDateString("en-IN", {
 day: "2-digit",
 month: "short",
 });
};
